<template>
  <component
    external
    :is="navigationDisabled ? 'div' : NuxtLink"
    :href="navigationDisabled ? null : '/'"
    class="logo-container"
    v-if="logo"
  >
    <StoryblokImg
      :image="logo.logo"
      v-if="logo.component == 'navbar-logo-image'"
    />
    <StoryblokVideo
      :video="logo.logo"
      :controls="false"
      :autoplay="true"
      :muted="true"
      :loop="true"
      v-else
    />
  </component>
</template>

<script lang="ts" setup>
import { NuxtLink } from "#components";
import {
  NavbarLogoImageStoryblok,
  NavbarLogoVideoStoryblok,
} from "~/types/bloks";

const props = defineProps<{
  logo: NavbarLogoImageStoryblok[] | NavbarLogoVideoStoryblok[];
  navigationDisabled?: boolean;
}>();

const logo = props.logo[0];
</script>

<style lang="scss" scoped>
.logo-container {
  user-select: none;
  display: block;
  width: 100px;
  max-height: 21px;

  @include screen-xs-min {
    width: 125px;
    max-height: 26px;
  }

  img {
    display: block;
    width: 100%;
  }

  .video-container {
    pointer-events: none;
  }
}
</style>
